// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1__c1be958aa7fca77ef50b","cls2":"CreateSocialItem-cls2__c56a11edc58e4523ad14 CreateSocialItem-cls1__c1be958aa7fca77ef50b"};